import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { BackButton } from 'C4';
import { contacts } from 'settings';

const Content = (props) => {
  const {
    address, image, organisation, phone, website, email: [email],
  } = props;

  return (
    <div className="contactView__Content">
      {image && <img src={image} alt={organisation} />}
      <h1>{organisation}</h1>
      <p><FontAwesomeIcon icon={['fas', 'envelope']} />{address}</p>
      <p><FontAwesomeIcon icon={['fas', 'phone']} />{phone}</p>
      {email && <a href={`mailto:${email}`}><FontAwesomeIcon icon={['fas', 'envelope']} />{email}</a>}
      <a href={website} target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={['fas', 'link']} />{website}</a>
      <hr />
    </div>
  );
};

const ContactView = () => (
  <div className="contentContainer contact">
    <div className="contactView__Header" />
    <div className="contactView">
      {contacts.map((contact) => {
        const {
          address, image, organisation, phone, website, email,
        } = contact;

        return (
          <Content
            address={address}
            email={email}
            image={image}
            key={organisation}
            organisation={organisation}
            phone={phone}
            website={website}
          />
        );
      })}
    </div>
  </div>
);

export default ContactView;

Content.propTypes = {
  address: PropTypes.string,
  email: PropTypes.arrayOf(PropTypes.string),
  image: PropTypes.string,
  organisation: PropTypes.string,
  phone: PropTypes.string,
  website: PropTypes.string,
};

Content.defaultProps = {
  address: null,
  email: [null],
  image: null,
  organisation: null,
  phone: null,
  website: null,
};
